export const OBSERVATORY_PAGES_ORDER_FOR_PERMISSIONS: string[] = [
  'public_agent_module_permission',
  'group_module_permission',
  'unified_person_attendance',
  'unified_person_residence',
  'origin_person_origin',
  'origin_person_data_hygiene',
  'origin_activity_primary_care',
  'origin_activity_attendance',
  'origin_activity_activity_type',
  'origin_activity_review',
  'origin_activity_cid',
  'origin_activity_execution',
  'origin_activity_vaccine',
  'place_flow',
  'alert',
]
